module.exports = __webpack_public_path__ + "img/1500.1f43b92c.svg";